import { render, staticRenderFns } from "./PartnerListItem.vue?vue&type=template&id=7ab83e6e"
import script from "./PartnerListItem.vue?vue&type=script&lang=ts"
export * from "./PartnerListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports